import clsx from 'clsx';
import { useState } from 'react';
import { ArrowDownIcon } from '@/components/icons/ArrowDownIcon';

type FAQDropdownProps = {
  question: string;
  answer: string;
  onToggle?: (open: boolean) => void;
  defaultOpen?: boolean;
};

export default function FAQDropdown({ question, answer, onToggle, defaultOpen = false }: FAQDropdownProps) {
  const [open, setOpen] = useState<boolean>(defaultOpen);

  const toggle = (): void => {
    setOpen((prev) => {
      const next = !prev;
      onToggle?.(next);
      return next;
    });
  };

  return (
    <div className="w-full">
      <div className={clsx('w-full bg-white border border-gray-200 rounded-xl overflow-hidden', { 'shadow-sm': open })}>
        <div
          aria-expanded={open}
          onClick={toggle}
          className="w-full flex items-center justify-between px-6 py-5 text-left min-h-[64px]"
        >
          <div className="flex-1 pr-4">
            <div className="text-lg lg:text-xl font-semibold text-black leading-7">{question}</div>
          </div>

          <div
            className={clsx('transform transition-transform duration-200', { 'rotate-180': open, 'rotate-0': !open })}
          >
            <ArrowDownIcon />
          </div>
        </div>

        <div
          className={clsx('overflow-hidden transition-all duration-200', { 'max-h-[400px]': open, 'max-h-0': !open })}
        >
          <div className="px-6 py-4 text-gray-700 leading-6 border-t border-gray-200">
            <div>{answer}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
